var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 6.26074L29.217 15.9999L15.9996 25.739L2.78223 15.9999L15.9996 6.26074Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5652C19.0736 21.5652 21.5652 19.0736 21.5652 16C21.5652 12.9264 19.0736 10.4348 16 10.4348C12.9264 10.4348 10.4348 12.9264 10.4348 16C10.4348 19.0736 12.9264 21.5652 16 21.5652Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2174 15.6521C12.2496 15.6521 11.3157 15.7993 10.4366 16.0724C10.4755 19.1124 12.9508 21.5652 16 21.5652C17.8855 21.5652 19.5508 20.6266 20.5574 19.1922C18.8351 17.0361 16.1851 15.6521 13.2174 15.6521Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4621 17.0663C21.5291 16.721 21.5653 16.3648 21.5653 16C21.5653 12.9264 19.0736 10.4348 16.0001 10.4348C13.7067 10.4348 11.7379 11.8224 10.8859 13.8035C11.6391 13.6474 12.4188 13.5653 13.2175 13.5653C16.4498 13.5652 19.3739 14.9088 21.4621 17.0663Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrazil);
export default __webpack_public_path__ + "static/media/flag_brazil.5165bbb99b73f66d625bd7461440e609.svg";
export { ForwardRef as ReactComponent };